var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAvailGreen(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9 10.5V12.5H7V10.5H9ZM9 4.5V9.5H7V4.5H9ZM8 1.5C6.14348 1.5 4.36301 2.2375 3.05025 3.55025C1.7375 4.86301 1 6.64348 1 8.5C1 10.3565 1.7375 12.137 3.05025 13.4497C4.36301 14.7625 6.14348 15.5 8 15.5C9.85652 15.5 11.637 14.7625 12.9497 13.4497C14.2625 12.137 15 10.3565 15 8.5C15 6.64348 14.2625 4.86301 12.9497 3.55025C11.637 2.2375 9.85652 1.5 8 1.5ZM8 14.5C7.21207 14.5 6.43185 14.3448 5.7039 14.0433C4.97595 13.7417 4.31451 13.2998 3.75736 12.7426C3.20021 12.1855 2.75825 11.5241 2.45672 10.7961C2.15519 10.0681 2 9.28793 2 8.5C2 7.71207 2.15519 6.93185 2.45672 6.2039C2.75825 5.47595 3.20021 4.81451 3.75736 4.25736C4.31451 3.70021 4.97595 3.25825 5.7039 2.95672C6.43185 2.65519 7.21207 2.5 8 2.5C8.78793 2.5 9.56815 2.65519 10.2961 2.95672C11.0241 3.25825 11.6855 3.70021 12.2426 4.25736C12.7998 4.81451 13.2417 5.47595 13.5433 6.2039C13.8448 6.93185 14 7.71207 14 8.5C14 9.28793 13.8448 10.0681 13.5433 10.7961C13.2417 11.5241 12.7998 12.1855 12.2426 12.7426C11.6855 13.2998 11.0241 13.7417 10.2961 14.0433C9.56815 14.3448 8.78793 14.5 8 14.5Z",
    fill: "#007A33"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAvailGreen);
export default __webpack_public_path__ + "static/media/avail_green.a37bb62e979d3a4b00c9424e4ef02b02.svg";
export { ForwardRef as ReactComponent };